import TextFieldInlineEdit from './TextFieldInlineEdit';
import i18n from '../../utils/i18n';
import {ISSUE_ATTRIBUTE_NAMES} from '../../constants/issue-attribute-names';
import {validateQualityIssueDescription} from '../../utils/validation-helpers';
import React from 'react';
import {issueAttributesType} from '../../constants/proptype-validation';
import PropTypes from 'prop-types';
import IssueFieldInlineEdit from './IssueFieldInlineEdit';
import {getRequiredFieldsFormatted} from '../../app/selectors';
import {connect} from '../../app/connect';
import {hasPermittedAttribute} from '../../utils/issues-helpers';

const DescriptionInlineEdit = ({issue, requiredFieldsMap, styleType, className}) => (
  <TextFieldInlineEdit
    issue={issue}
    label={i18n.t('new.description')}
    placeholder={hasPermittedAttribute(issue, ISSUE_ATTRIBUTE_NAMES.DESCRIPTION)
      ? i18n.t('preview.details.noDescription')
      : i18n.t('unspecifiedValue')}
    attributeName={ISSUE_ATTRIBUTE_NAMES.DESCRIPTION}
    className={className}
    data-testid="DescriptionInlineEdit"
    styleType={styleType}
    isRequired={requiredFieldsMap[ISSUE_ATTRIBUTE_NAMES.DESCRIPTION]}
    linkify
    inputValidator={validateQualityIssueDescription}
  />
);

DescriptionInlineEdit.displayName = 'DescriptionInlineEdit';

DescriptionInlineEdit.propTypes = {
  issue: issueAttributesType,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes)),
  requiredFieldsMap: PropTypes.object.isRequired,
  className: PropTypes.string
};

const mapStateToProps = state => ({
  requiredFieldsMap: getRequiredFieldsFormatted(state)
});

export default connect(mapStateToProps)(DescriptionInlineEdit);
